<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-dialog v-model="posicoesDialog" width="80%" @close="closePosicoesDialog">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            <strong>{{ posicoesDialogTitle }}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon dark @click="closePosicoesDialog">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
          <v-data-table :headers="headersPosicoes" :items="posicoes" dense class="elevation-7" locale="pt"
            :loading="loadingPosicoesDialog" :loading-text="$t('system.messages.loading')" :item-class="getColorPosicao"
            style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px;">
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="relman-tabs mb-4" flat>
      <v-tabs v-model="tab" @change="buildHeader" background-color="white">
        <v-tab v-for="aba in abasRelManutencao" :key="aba.key">{{ aba.label }}</v-tab>
      </v-tabs>
    </v-card>

    <v-container class="toolbar__container mb-4">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="2">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <MultiplaEscolha
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timePropsInicio"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timePropsFim"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="3" v-if="!isAbaComunicacao">
            <v-select
              v-model="manutencaoFilterType"
              :items="manutencaoFilterTypeOptions"
              :label="$t('relMaintenanceHistory.otherEquipment.filterBy')"
              dense
              hide-details
              @change="onManutencaoFilterTypeChanged"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" v-if="!isAbaComunicacao">
            <MultiplaEscolha
              v-if="manutencaoFilterType === 'equipamento'"
              ref="equipamentosSelect"
              lazy
              get-url="getEquipamentoslazy"
              :request-data="equipamentosLazyRequestData"
              v-bind:selected-items.sync="idEquipamentosSelected"
              text="cod_equipamento"
              value="id_equipamento"
              :label="$tc('equipment.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
            <MultiplaEscolha
              v-else-if="manutencaoFilterType === 'veiculo'"
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
            <MultiplaEscolha
              v-else
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idLinhaSelected"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3" v-if="isAbaComunicacao">
            <v-select
              v-model="outrosFilterType"
              :items="outrosFilterTypeOptions"
              :label="$t('relMaintenanceHistory.otherEquipment.filterBy')"
              dense
              hide-details
              @change="onOutrosFilterTypeChanged"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" v-if="isAbaComunicacao">
            <MultiplaEscolha
              v-if="outrosFilterType === 'equipamento'"
              ref="outrosEquipamentosSelect"
              lazy
              get-url="getEquipamentoslazy"
              :request-data="equipamentosLazyRequestData"
              v-bind:selected-items.sync="outrosIdEquipamentosSelected"
              text="cod_equipamento"
              value="id_equipamento"
              :label="$tc('equipment.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
            <MultiplaEscolha
              v-else-if="outrosFilterType === 'veiculo'"
              ref="outrosVeiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="outrosIdVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
            <MultiplaEscolha
              v-else
              ref="outrosLinhasSelect"
              lazy
              get-url="getLinhaslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="outrosIdLinhasSelected"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 2)"
              :max-items="2"
              :can-toggle-all="true"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-data-table :headers="isAbaComunicacao ? headersOutros : headersEquipamento" :items="isAbaComunicacao ? outrosResultado : agregadoEquipamentos" sort-by="manutencao" :sort-desc="true"
      :item-key="isAbaComunicacao ? 'id_equipamento' : 'chave_unica'" :show-expand="!isAbaComunicacao" :single-expand="true" dense class="elevation-7" locale="pt" :loading="isAbaComunicacao ? loadingOutros : loading"
      :loading-text="$t('system.messages.loading')" :search="searchAtual" :item-class="getColorItem"
      style="border-radius: 10px; margin-bottom: 10px;" @update:sort-by="updateSort($event)"
      @update:sort-desc="updateSortDesc($event)">
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="margin: 0;padding: 5px;">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>{{ $t('relMaintenence.headerMaintenence.positionSent') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.lostPosition') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.invalidPosition') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.sentPositionCommercial') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.lostPositionCommercial') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.sentPositionClosed') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.lostPositionClosed') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.outOfOrder') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.withDelay') }}</th>
                  <th>{{ $t('relMaintenence.headerMaintenence.detail') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.total_posicoes }}</td>
                  <td>{{ item.total_posicoes_perdidas }}</td>
                  <td>{{ item.total_posicoes_invalidas }}</td>
                  <td>{{ item.total_posicoes_comercial }}</td>
                  <td>{{ item.total_posicoes_perdidas_comercial }}</td>
                  <td>{{ item.total_posicoes_fechado }}</td>
                  <td>{{ item.total_posicoes_perdidas_fechado }}</td>
                  <td>{{ item.total_posicoes_fora_ordem }}</td>
                  <td>{{ item.total_posicoes_delay }}</td>
                  <td>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon color="blue" v-on="on"
                          @click="showPosicoesDialog(item)">mdi-map-marker-multiple</v-icon>
                      </template>
                      <span>{{ $t('relMaintenence.seeAllPositions') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ tituloAbaAtual }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="searchAtual" append-icon="mdi-magnify" :label="$t('system.search')" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>
          <vue-json-to-csv :json-data="isAbaComunicacao ? outrosResultado : agregadoEquipamentosSorted" :csv-title="filenameAbaAtual" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <ExportTablePdf :title="tituloAbaAtual"
            :content="isAbaComunicacao ? outrosResultado : agregadoEquipamentosSorted"
            :headers="isAbaComunicacao ? headersOutros : headersEquipamento" :filename="filenameAbaAtual"
            :subtitle="`${razaoSocial} | ${$t('relVehicleKm.refDate')}: ${dataPdfInicial} - ${dataPdfFinal}`">
          </ExportTablePdf>
        </v-toolbar>
      </template>

      <template v-slot:item.p_envio_total="{ item }">
        <span :class="percentClassManutencao(item, 'envio')">{{ item.p_envio_total }}%</span>
      </template>

      <template v-slot:item.p_posicoes_fora_ordem="{ item }">
        <span :class="percentClassLimiteMaximo(item, 'p_posicoes_fora_ordem', 'limite_fora_ordem')">
          {{ item.p_posicoes_fora_ordem }}%
        </span>
      </template>

      <template v-slot:item.p_delay="{ item }">
        <span :class="percentClassLimiteMaximo(item, 'p_delay', 'limite_delay')">{{ item.p_delay }}%</span>
      </template>

      <template v-slot:item.p_validas="{ item }">
        <span :class="percentClassManutencao(item, 'validas')">{{ item.p_validas }}%</span>
      </template>

      <template v-slot:item.status_dot="{ item }">
        <span v-if="isAbaComunicacao" class="status-dot" :style="{ backgroundColor: statusDotColor(item) }" :title="item.status_label"></span>
      </template>

      <template v-slot:item.status_geotab_extenso="{ item }">
        <span class="status-geotab-cell">
          <span class="status-dot" :style="{ backgroundColor: statusGeotabDotColor(item.status_geotab_real) }" :title="item.status_geotab_extenso"></span>
          <span>{{ item.status_geotab_extenso }}</span>
        </span>
      </template>

      <template v-slot:item.manutencao="{ item }">
        <template v-if="isAbaComunicacao">
          <v-chip :color="getCorChipManutencaoOutros(item)" dark small>
            <template v-if="!item.manutencao">{{ $t('relMaintenanceHistory.otherEquipment.ok') }}</template>
            <template v-else-if="item.horas_sem_atualizar === null">{{ $t('relMaintenanceHistory.otherEquipment.noUpdate') }}</template>
            <template v-else>{{ $t('relMaintenanceHistory.otherEquipment.hoursWithoutUpdate', { hours: item.horas_sem_atualizar }) }}</template>
          </v-chip>
        </template>
        <template v-else>
          <v-chip v-if="item.cod_equipamento" :color="item.manutencao ? 'red darken-1' : 'green'" dark small class="font-weight-medium">
            {{ item.manutencao ? item.manutencao : $t('relMaintenanceHistory.otherEquipment.ok') }}
          </v-chip>
          <span v-else class="grey--text">—</span>
        </template>
      </template>

    </v-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DateUtils from "../utils/dateutils";
import ExportTablePdf from "./ExportTablePdf.vue";
import VueJsonToCsv from "vue-json-to-csv";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf,
    MultiplaEscolha,
    LazySelect,
  },
  data: () => ({
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    user: null,
    token: null,
    tab: 0,
    config: null,
    relManutencaoTiposEquipamentos: {
      validadores: [],
      rastreadores: [],
      validadores_rastreadores_bilhetagem: [],
      dvr: [],
    },
    loading: false,
    search: "",
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    empresaRazaoSocial: null,
    idLinhaSelected: [],
    idEquipamentosSelected: [],
    searchAgregado: "",
    headersAgregado: null,
    agregado: [],
    agregadoViagens: [],
    agregadoEquipamentos: [],
    agregadoSentidos: [],
    agregadoLinhas: [],
    veiculos: [],
    idVeiculosSelected: [],
    unidadesSelecionadas: [],
    formValidado: false,
    sortBy: null,
    sortDesc: false,
    posicoesDialog: false,
    loadingPosicoesDialog: false,
    posicoes: [],
    veiculoClicked: null,
    outrosEquipamentos: [],
    outrosResultado: [],
    manutencaoFilterType: 'veiculo',
    outrosFilterType: 'equipamento',
    outrosIdEquipamentosSelected: [],
    outrosIdVeiculosSelected: [],
    outrosIdLinhasSelected: [],
    searchOutros: "",
    loadingOutros: false,
    outrosEquipamentosCarregados: false,
    outrosEquipamentosCache: {},
    outrosEquipamentosCarregadosPorAba: {},
  }),
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    unidadesSelecionadas() {
      this.onManutencaoFilterTypeChanged();
      this.onOutrosFilterTypeChanged();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.headersAgregado = this.headers;
    this.agregado = this.agregadoViagens;
    this.getConfig();
    this.initialize();
  },
  computed: {
    abasRelManutencao() {
      return [
        { key: 'validadores', label: 'Validadores', tipo: 'comunicacao', filename: 'relmanutencao_validadores' },
        { key: 'rastreadores', label: 'Rastreadores', tipo: 'metricas', filename: 'relmanutencao_rastreadores' },
        { key: 'validadores_rastreadores_bilhetagem', label: 'Validador/Rastreador', tipo: 'metricas', filename: 'relmanutencao_validadores_rastreadores_bilhetagem' },
        { key: 'dvr', label: 'DVR', tipo: 'comunicacao', filename: 'relmanutencao_dvr' },
      ];
    },
    abaAtual() {
      return this.abasRelManutencao[this.tab] || this.abasRelManutencao[0];
    },
    isAbaComunicacao() {
      return this.abaAtual.tipo === 'comunicacao';
    },
    idsTiposEquipamentoAbaAtual() {
      const ids = this.relManutencaoTiposEquipamentos[this.abaAtual.key];
      return Array.isArray(ids) ? ids : [];
    },
    tituloAbaAtual() {
      return this.abaAtual.label;
    },
    filenameAbaAtual() {
      return this.abaAtual.filename;
    },
    headersPosicoes() {
      return [
        { text: this.$t('datetime.positionDate'), value: "dt_posicao_extenso" },
        { text: this.$t('datetime.inclusionDate'), value: "dt_inclusao_extenso" },
        { text: this.$t('relMaintenence.headerPositions.lat'), value: "lat" },
        { text: this.$t('relMaintenence.headerPositions.lng'), value: "lng" },
        { text: this.$t('relMaintenence.headerPositions.valid'), value: "valida" },
        { text: this.$t('relMaintenence.headerPositions.outOfOrder'), value: "fora_de_ordem" },
        { text: this.$t('relMaintenence.headerPositions.delay'), value: "delay" },
      ];
    },
    headersEquipamento() {
      const headers = [
        { text: this.$t('relMaintenence.headerEquipment.code'), value: "cod_equipamento" },
        { text: this.$t('relMaintenence.headerEquipment.vehicle'), value: "numero_ordem" },
        { text: this.$t('relMaintenence.headerEquipment.model'), value: "modelo" },
        { text: this.$t('relMaintenence.headerEquipment.type'), value: "nome_tipo_equipamento" },
        { text: this.$t('relMaintenence.headerEquipment.maintenance'), value: "manutencao" },
        { text: this.$t('relMaintenence.headerEquipment.percentageSend'), value: "p_envio_total" },
        { text: this.$t('relMaintenence.headerEquipment.percentageValid'), value: "p_validas" },
        { text: this.$t('relMaintenence.headerEquipment.percentageOutOfOrder'), value: "p_posicoes_fora_ordem" },
        { text: this.$t('relMaintenence.headerEquipment.percentageDelay'), value: "p_delay" },
        { text: this.$t('relMaintenence.headerEquipment.lastValidPosition'), value: "dt_ultima_posicao" },
      ];
      if (this.abaAtual.key === 'validadores_rastreadores_bilhetagem') {
        headers.push({ text: this.$t('relMaintenence.headerEquipment.lastBill'), value: "dt_ultima_bilhetagem" });
      }
      headers.push(
        { text: this.$t('relMaintenence.headerEquipment.lastGuide'), value: "dt_ultima_guia" },
        { text: this.$t('relMaintenence.headerEquipment.lastPosition'), value: "ultima_posicao" },
      );
      if (this.abaAtual.key !== 'validadores_rastreadores_bilhetagem') {
        headers.push(
          { text: this.$t('relMaintenence.headerEquipment.isDriving'), value: "is_driving_extenso" },
          { text: this.$t('relMaintenence.headerEquipment.statusGeotabReal'), value: 'status_geotab_extenso' },
        );
      }
      return headers;
    },
    headersSentido() {
      return [
        { text: this.$t('relMaintenence.headerDirection.direction'), value: "descricao_sentido" },
        { text: this.$t('relMaintenence.headerDirection.percentageSend'), value: "p_enviadas" },
        { text: this.$t('relMaintenence.headerDirection.percentageOutOfOrder'), value: "p_fora_ordem" },
        { text: this.$t('relMaintenence.headerDirection.percentageDelay'), value: "p_delay" }]
    },
    headersLinha() {
      return [
        { text: this.$t('relMaintenence.headerLine.line'), value: "cod_linha" },
        { text: this.$t('relMaintenence.headerLine.percentageSend'), value: "p_enviadas" },
        { text: this.$t('relMaintenence.headerLine.percentageOutOfOrder'), value: "p_fora_ordem" },
        { text: this.$t('relMaintenence.headerLine.percentageDelay'), value: "p_delay" }]
    },
    razaoSocial() {
      return this.empresaRazaoSocial || this.$t('realTimeKmReport.allCompanies');
    },
    dataPdfInicial() {
      return this.dti ? this.dti.toLocaleString() : null;
    },
    dataPdfFinal() {
      return this.dtf ? this.dtf.toLocaleString() : null;
    },
    posicoesDialogTitle() {
      return this.veiculoClicked ? this.$t('relMaintenence.vehiclePositions', { numero_ordem: this.veiculoClicked.numero_ordem }) : this.$t('relMaintenence.positions');
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    yesterday() {
      let d = new Date();
      d.setDate(d.getDate() - 1)
      return d.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min,
        max: this.today
      }
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [this.dateTimeRules], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      };
    },
    timePropsInicio() {
      return {
        useSeconds: false,
        allowedMinutes: ["00"],
        allowedHours: this.allowedHoursInicio,
      }
    },
    timePropsFim() {
      return {
        useSeconds: false,
        allowedMinutes: ["00"],
        allowedHours: this.allowedHoursFim,
      }
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
    equipamentosLazyRequestData() {
      return {
        ...this.lazySelectRequestData,
        id_tipos_equipamento: this.idsTiposEquipamentoAbaAtual,
      };
    },
    agregadoEquipamentosSorted() {
      if (!this.sortBy) {
        return this.agregadoEquipamentos;
      }

      if (["p_envio_operacao", "p_envio_total", "p_posicoes_fora_ordem", "p_delay"].includes(this.sortBy)) {
        return [...this.agregadoEquipamentos.filter((e) => !isNaN(parseFloat(e[this.sortBy]))).sort((a, b) => {
          let result = 0;

          if (parseFloat(a[this.sortBy]) > parseFloat(b[this.sortBy])) {
            result = 1;
          } else if (parseFloat(a[this.sortBy]) == parseFloat(b[this.sortBy])) {
            result = 0;
          } else {
            result = -1;
          }
          return this.sortDesc ? -1 * result : result;
        }), ...this.agregadoEquipamentos.filter((e) => isNaN(parseFloat(e[this.sortBy])))];
      } else {
        return [...this.agregadoEquipamentos].sort((a, b) => {
          let result = 0;

          if (!a[this.sortBy]) {
            result = -1;
          } else if (!b[this.sortBy]) {
            result = 1;
          } else {
            if (a[this.sortBy] > b[this.sortBy]) {
              result = 1;
            } else if (a[this.sortBy] == b[this.sortBy]) {
              result = 0;
            } else {
              result = -1;
            }
          }

          return this.sortDesc ? -1 * result : result;
        });
      }

    },
    outrosFilterTypeOptions() {
      return [
        { text: this.$tc('equipment.self', 1), value: 'equipamento' },
        { text: this.$tc('vehicle.self', 1), value: 'veiculo' },
        { text: this.$tc('line.self', 1), value: 'linha' }
      ];
    },
    manutencaoFilterTypeOptions() {
      return [
        { text: this.$tc('equipment.self', 1), value: 'equipamento' },
        { text: this.$tc('vehicle.self', 1), value: 'veiculo' },
        { text: this.$tc('line.self', 1), value: 'linha' }
      ];
    },
    headersOutros() {
      return [
        { text: '', value: 'status_dot', sortable: false, width: '48px', align: 'center' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.communicationStatus'), value: 'status_label' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.equipment'), value: 'cod_equipamento' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.name'), value: 'nome_equipamento' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.type'), value: 'nome_tipo_equipamento' },
        { text: this.$tc('vehicle.self', 1), value: 'numero_ordem' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.lastUpdate'), value: 'dt_ultima_atualizacao_comunicacao_extenso' },
        { text: this.$t('relMaintenanceHistory.otherEquipment.lastHoursColumn', { hours: this.limiteHorasAtualizacao }), value: 'manutencao', sortable: false }
      ];
    },
    limiteHorasAtualizacao() {
      return Number(this.config && this.config.limite_horas_atualizacao_equipamento) || 24;
    },
    veiculoPorId() {
      return this.veiculos.reduce((acc, veiculo) => {
        acc[Number(veiculo.id_veiculo)] = veiculo;
        return acc;
      }, {});
    },
    searchAtual: {
      get() {
        return this.isAbaComunicacao ? this.searchOutros : this.searchAgregado;
      },
      set(v) {
        if (this.isAbaComunicacao) {
          this.searchOutros = v;
        } else {
          this.searchAgregado = v;
        }
      }
    }
  },
  methods: {
    filtraItensLazyParaIds(dados) {
      if (!dados || !Array.isArray(dados)) {
        return [];
      }
      let filtrados = dados;
      if (this.idEmpresaSelected) {
        filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
      } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
        filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
      }
      if (this.unidadesSelecionadas && this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        filtrados = filtrados.filter((d) => {
          if (Array.isArray(d.unidades) && d.unidades.length > 0) {
            return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
          }
          if (d.id_unidade != null && d.id_unidade !== '') {
            return selecionadas.includes(Number(d.id_unidade));
          }
          if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
            return true;
          }
          return selecionadas.includes(-1);
        });
      }
      return filtrados;
    },
    async resolveLazySelectIds(refName, selectedIds, valueKey, requestDataOverride = null) {
      if (Array.isArray(selectedIds) && selectedIds.length > 0) {
        return { ids: selectedIds, implicit: false };
      }
      const selectRef = this.$refs[refName];
      if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
        return { ids: [], implicit: true };
      }
      const override = requestDataOverride != null
        ? requestDataOverride
        : this.lazySelectRequestData;
      const { items } = await selectRef.fetchAllLazyItems({
        search: '',
        requestDataOverride: override,
      });
      const ids = this.filtraItensLazyParaIds(items || [])
        .map((item) => item[valueKey])
        .filter((id) => id != null && id !== '');
      return { ids, implicit: true };
    },
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    passaFiltroEmpresaOutros(equip) {
      if (!this.idEmpresaSelected) {
        return true;
      }
      return Number(equip.id_empresa) === Number(this.idEmpresaSelected);
    },
    passaFiltroUnidadesOutros(equip) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const veiculo = this.veiculoPorId[Number(equip.id_veiculo)];
      return veiculo ? this.passaFiltroUnidades(veiculo) : false;
    },
    passaFiltroDataOutros(equip) {
      if (!this.dti || !equip.dt_ultima_atualizacao_comunicacao) {
        return true;
      }
      const dataInicial = new Date(this.dti);
      const atualizacao = new Date(String(equip.dt_ultima_atualizacao_comunicacao).replace(' ', 'T'));
      if (isNaN(dataInicial.getTime()) || isNaN(atualizacao.getTime())) {
        return true;
      }
      return atualizacao >= dataInicial;
    },
    passaFiltrosBaseOutros(equip, options) {
      const filtrarData = !options || options.filtrarData !== false;
      return this.passaFiltroEmpresaOutros(equip)
        && this.passaFiltroUnidadesOutros(equip)
        && (!filtrarData || this.passaFiltroDataOutros(equip));
    },
    filtraVeiculosParaRelatorio(veiculos) {
      let filtrados = Array.isArray(veiculos) ? veiculos : [];
      if (this.idEmpresaSelected) {
        filtrados = filtrados.filter((v) => Number(v.id_empresa) === Number(this.idEmpresaSelected));
      }
      return filtrados.filter((v) => this.passaFiltroUnidades(v));
    },
    async carregaOutrosEquipamentosManutencao(force) {
      const abaKey = this.abaAtual.key;
      if (this.outrosEquipamentosCarregadosPorAba[abaKey] && !force) {
        this.outrosEquipamentos = this.outrosEquipamentosCache[abaKey] || [];
        return;
      }
      this.loadingOutros = true;
      const endpoint = abaKey === 'dvr'
        ? apiController.endpoints.getEquipamentosdvr
        : apiController.endpoints.getEquipamentosvalidadores;
      try {
        await apiController.request(endpoint, {
          data: {
            idsTiposEquipamento: this.idsTiposEquipamentoAbaAtual,
          },
          onSuccess: (response) => {
            this.outrosEquipamentos = response.data || [];
            this.outrosEquipamentosCache = {
              ...this.outrosEquipamentosCache,
              [abaKey]: this.outrosEquipamentos,
            };
            this.outrosEquipamentosCarregadosPorAba = {
              ...this.outrosEquipamentosCarregadosPorAba,
              [abaKey]: true,
            };
            this.outrosEquipamentosCarregados = true;
          },
          onError: () => {
            this.loadingOutros = false;
          }
        });
      } catch (e) {
        // apiController already emits the user-facing error notification.
      } finally {
        this.loadingOutros = false;
      }
    },
    onOutrosFilterTypeChanged() {
      this.outrosIdEquipamentosSelected = [];
      this.outrosIdVeiculosSelected = [];
      this.outrosIdLinhasSelected = [];
      this.$nextTick(() => {
        if (this.$refs.outrosEquipamentosSelect && this.$refs.outrosEquipamentosSelect.setSelectedItems) {
          this.$refs.outrosEquipamentosSelect.setSelectedItems([]);
        }
        if (this.$refs.outrosVeiculosSelect && this.$refs.outrosVeiculosSelect.setSelectedItems) {
          this.$refs.outrosVeiculosSelect.setSelectedItems([]);
        }
        if (this.$refs.outrosLinhasSelect && this.$refs.outrosLinhasSelect.setSelectedItems) {
          this.$refs.outrosLinhasSelect.setSelectedItems([]);
        }
      });
    },
    onManutencaoFilterTypeChanged() {
      this.idLinhaSelected = [];
      this.idVeiculosSelected = [];
      this.idEquipamentosSelected = [];
      this.$nextTick(() => {
        if (this.$refs.equipamentosSelect && this.$refs.equipamentosSelect.setSelectedItems) {
          this.$refs.equipamentosSelect.setSelectedItems([]);
        }
        if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.setSelectedItems) {
          this.$refs.veiculosSelect.setSelectedItems([]);
        }
        if (this.$refs.linhasSelect && this.$refs.linhasSelect.setSelectedItems) {
          this.$refs.linhasSelect.setSelectedItems([]);
        }
      });
    },
    horasSemAtualizar(equip) {
      // Diferença em horas entre agora e hikvision_acs_device_dt_atualizacao.
      // Retorna null quando não há data válida (nunca atualizou).
      if (!equip.dt_ultima_atualizacao_comunicacao) {
        return null;
      }
      const last = new Date(String(equip.dt_ultima_atualizacao_comunicacao).replace(' ', 'T'));
      if (isNaN(last.getTime())) {
        return null;
      }
      return Math.floor((Date.now() - last.getTime()) / 3600000);
    },
    recomendaManutencao(equip) {
      const horas = this.horasSemAtualizar(equip);
      if (horas === null) {
        return true;
      }
      return horas > this.limiteHorasAtualizacao;
    },
    getCorChipManutencaoOutros(equip) {
      if (!equip.manutencao) {
        return 'green';
      }
      if (equip.horas_sem_atualizar === null) {
        return 'red';
      }
      return 'yellow darken-2';
    },
    statusDotColor(equip) {
      // 'status' é numérico (0 = unknown, 1 = online, 2 = offline) e não passa
      // pelo tradutor do backend, ao contrário de 'status_extenso'.
      switch (Number(equip.status)) {
        case 1: return '#4CAF50';
        case 2: return '#F44336';
        default: return '#FFFFFF';
      }
    },
    statusGeotabDotColor(value) {
      // status_geotab_real: 0 = offline, 1 = online.
      switch (Number(value)) {
        case 1: return '#4CAF50';
        case 0: return '#F44336';
        default: return '#FFFFFF';
      }
    },
    async populaOutrosResultado() {
      this.loadingOutros = true;
      await this.carregaOutrosEquipamentosManutencao();
      let lista = this.outrosEquipamentos.filter((e) => this.passaFiltrosBaseOutros(e));
      if (this.outrosFilterType === 'equipamento') {
        const { ids } = await this.resolveLazySelectIds(
          'outrosEquipamentosSelect',
          this.outrosIdEquipamentosSelected,
          'id_equipamento',
          this.equipamentosLazyRequestData,
        );
        const idsEquipamentos = new Set(ids.map((id) => Number(id)));
        lista = lista.filter((e) => idsEquipamentos.has(Number(e.id_equipamento)));
      } else if (this.outrosFilterType === 'veiculo') {
        const { ids } = await this.resolveLazySelectIds(
          'outrosVeiculosSelect',
          this.outrosIdVeiculosSelected,
          'id_veiculo',
        );
        const idsVeiculos = new Set(ids.map((id) => Number(id)));
        lista = lista.filter((e) => idsVeiculos.has(Number(e.id_veiculo)));
      } else if (this.outrosFilterType === 'linha') {
        const { ids } = await this.resolveLazySelectIds(
          'outrosLinhasSelect',
          this.outrosIdLinhasSelected,
          'id_linha',
        );
        const idsLinhas = new Set(ids.map((id) => Number(id)));
        lista = lista.filter((e) => {
          const veiculo = this.veiculoPorId[Number(e.id_veiculo)];
          return veiculo && idsLinhas.has(Number(veiculo.id_linha));
        });
      }
      this.outrosResultado = lista.map((e) => {
        const veiculo = this.veiculoPorId[Number(e.id_veiculo)];
        const horasSemAtualizar = this.horasSemAtualizar(e);
        return {
          ...e,
          numero_ordem: e.numero_ordem || (veiculo ? veiculo.numero_ordem : null) || e.cod_veiculo || '-',
          // status_extenso já vem traduzido pelo backend (Online/Offline/Desconhecido).
          status_label: e.status_extenso || this.$t('relMaintenanceHistory.otherEquipment.status.unknown'),
          horas_sem_atualizar: horasSemAtualizar,
          manutencao: horasSemAtualizar === null || horasSemAtualizar > this.limiteHorasAtualizacao
        };
      });
      this.loadingOutros = false;
    },
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
      }
      this.$router.push({ path: "/" });
    },
    initialize() {
      this.populaVeiculos();
      this.getRelManutencaoTiposEquipamentos();
      this.outrosEquipamentos = [];
      this.outrosResultado = [];
      this.outrosEquipamentosCarregados = false;
      this.outrosEquipamentosCache = {};
      this.outrosEquipamentosCarregadosPorAba = {};
    },
    getRelManutencaoTiposEquipamentos() {
      apiController.request(apiController.endpoints.getRelmanutencaotiposequipamentos, {
        onSuccess: (response) => {
          this.relManutencaoTiposEquipamentos = {
            ...this.relManutencaoTiposEquipamentos,
            ...(response.data || {}),
          };
          this.outrosEquipamentosCache = {};
          this.outrosEquipamentosCarregadosPorAba = {};
          this.outrosEquipamentosCarregados = false;
        },
      });
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
        },
      });
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      const item = this.$refs.empresaSelect && this.$refs.empresaSelect.getCachedSelectedItem
        ? this.$refs.empresaSelect.getCachedSelectedItem(id)
        : null;
      this.empresaRazaoSocial = item && item.razao_social ? item.razao_social : null;
      this.onManutencaoFilterTypeChanged();
      this.onOutrosFilterTypeChanged();
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculos, {
        onSuccess: (response) => {
          this.veiculos = response.data || [];
        },
      });
    },
    // populaViagens(body) {
    //     axios
    //         .post(ApiBaseUrl + `/api/v1.0/getagregadomanutencaoviagens/`, body, {
    //             headers: { "x-access-token": this.token },
    //         })
    //         .then((response) => {
    //             this.agregadoViagens = response.data;
    //             this.populaAgregadoEquipamentos(body);
    //         })
    //         .catch((e) => {
    //             console.log(this.$t('system.messages.errorAxios'));
    //             console.log(e.message);
    //             if (e.message == "Request failed with status code 401") {
    //                 this.mensagemAutorizacaoDialog =
    //                 this.$t('system.messages.accessDenied');
    //                 this.autorizacaoDialog = true;
    //             }
    //         });
    // },
    populaAgregadoEquipamentos(body) {
      const endpoint = this.abaAtual.key === 'rastreadores'
        ? apiController.endpoints.getEquipamentosrastreadores
        : apiController.endpoints.getEquipamentosvalidadoresrastreadoresbilhetagem;
      apiController.request(endpoint, {
        data: body,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((e) => this.passaFiltroUnidades(e));
          this.agregadoEquipamentos = dados;
          if (!this.sortBy) {
            this.sortBy = "manutencao";
            this.sortDesc = true;
          }
          // this.populaAgregadoLinhas(body);
          this.loading = false;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    // populaAgregadoLinhas(body) {
    //   axios
    //     .post(ApiBaseUrl + `/api/v1.0/getagregadomanutencaolinhas/`, body, {
    //       headers: { "x-access-token": this.token },
    //     })
    //     .then((response) => {
    //       this.agregadoLinhas = response.data;
    //       this.populaAgregadoSentidos(body);
    //     })
    //     .catch((e) => {
    //       this.loading = false;
    //       console.log(this.$t('system.messages.errorAxios'));
    //       console.log(e.message);
    //     });
    // },
    // populaAgregadoSentidos(body) {
    //   axios
    //     .post(ApiBaseUrl + `/api/v1.0/getagregadomanutencaosentidos/`, body, {
    //       headers: { "x-access-token": this.token },
    //     })
    //     .then((response) => {
    //       this.agregadoSentidos = response.data;
    //       this.loading = false;
    //       this.buildHeader();
    //     })
    //     .catch((e) => {
    //       this.loading = false;
    //       console.log(this.$t('system.messages.errorAxios'));
    //       console.log(e.message);
    //     });
    // },
    async populaAgregados() {
      const dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      const dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

      const finish = (ids, param) => {
        this.populaAgregadoEquipamentos({
          ids,
          dti: dataInicial,
          dtf: dataFinal,
          param,
          idsTiposEquipamento: this.idsTiposEquipamentoAbaAtual,
        });
      };

      if (this.idEquipamentosSelected.length > 0) {
        finish(this.idEquipamentosSelected, 'equipamento');
        return;
      }
      if (this.idLinhaSelected.length > 0) {
        finish(this.idLinhaSelected, 'linha');
        return;
      }
      if (this.idVeiculosSelected.length > 0) {
        finish(this.idVeiculosSelected, 'veiculo');
        return;
      }

      try {
        if (this.manutencaoFilterType === 'equipamento') {
          const { ids } = await this.resolveLazySelectIds(
            'equipamentosSelect',
            [],
            'id_equipamento',
            this.equipamentosLazyRequestData,
          );
          finish(ids, 'equipamento');
        } else if (this.manutencaoFilterType === 'veiculo') {
          const { ids } = await this.resolveLazySelectIds('veiculosSelect', [], 'id_veiculo');
          finish(ids, 'veiculo');
        } else {
          const { ids } = await this.resolveLazySelectIds('linhasSelect', [], 'id_linha');
          finish(ids, 'linha');
        }
      } catch {
        this.loading = false;
      }
    },
    async populaRelatorio() {
      if (this.isAbaComunicacao) {
        this.populaOutrosResultado();
        return;
      }
      this.formValidado = this.$refs.form.validate();
      if (this.formValidado) {
        this.loading = true;
        this.searchAgregado = "";
        await this.populaAgregados();
      }
    },
    buildHeader() {
      this.outrosResultado = [];
      this.agregadoEquipamentos = [];
      this.searchOutros = "";
      this.searchAgregado = "";
      if (this.isAbaComunicacao) {
        this.onOutrosFilterTypeChanged();
        this.carregaOutrosEquipamentosManutencao();
      } else {
        this.onManutencaoFilterTypeChanged();
      }
    },
    updateSort(event) {
      this.sortBy = event;
    },
    updateSortDesc(event) {
      this.sortDesc = event;
    },
    dateTimeRules(v) {
      if (!v) {
        return this.$t('contract.messages.selectDate')
      }

      if (this.dtf <= this.dti) {
        return this.$t('datetime.startDateAfterEndDate');
      }

      return true;
    },
    allowedHoursInicio(v) {
      if (this.dti && this.dtf) {
        if (this.dti.toISOString().substring(0, 10) == this.dtf.toISOString().substring(0, 10)) {
          return v < this.dtf.getHours();
        }
      }

      return true;
    },
    allowedHoursFim(v) {
      if (this.dti && this.dtf) {
        if (this.dti.toISOString().substring(0, 10) == this.dtf.toISOString().substring(0, 10)) {
          return v > this.dti.getHours();
        }
      }

      return true;
    },
    showPosicoesDialog(veiculo) {
      this.veiculoClicked = veiculo;
      this.posicoesDialog = true;
      this.loadingPosicoesDialog = true;

      let body = {
        idveiculo: veiculo.id_veiculo,
        dti: DateUtils.getDateSQLFormatted(this.dti),
        dtf: DateUtils.getDateSQLFormatted(this.dtf)
      }

      apiController.request(apiController.endpoints.getPosicoesporcarrodatamanutencao, {
        data: body,
        onSuccess: (response) => {
          this.posicoes = response.data;
          this.loadingPosicoesDialog = false;
        },
        onError: () => {
          this.loadingPosicoesDialog = false;
        },
      });
    },
    closePosicoesDialog() {
      this.posicoesDialog = false;
      this.posicoes = [];
      this.loadingPosicoesDialog = false;
      this.veiculoClicked = null;
    },
    percentClassManutencao(item, campo) {
      // Envio e Válidas: a cor segue o diagnóstico 'manutencao' já calculado no backend
      // (que usa limiares por tipo de equipamento), em vez de recomparar contra limiares
      // globais no front — evita a % aparecer verde enquanto o chip já indica problema.
      if (!item.cod_equipamento) {
        return '';
      }
      if (!item.manutencao) {
        return 'relman-pct-good';
      }
      if (item.manutencao === 'GPS') {
        return campo === 'validas' ? 'relman-pct-bad' : 'relman-pct-good';
      }
      if (item.manutencao === 'MODEM') {
        return campo === 'envio' ? 'relman-pct-bad' : 'relman-pct-good';
      }
      // 'MODEM E GPS': envio e válidas estão fora do limite.
      return 'relman-pct-bad';
    },
    percentClassLimiteMaximo(item, campoValor, campoLimite) {
      if (!item.cod_equipamento || item[campoLimite] === null || item[campoLimite] === '') {
        return '';
      }
      const valor = Number(item[campoValor]);
      const limite = Number(item[campoLimite]);
      if (!Number.isFinite(valor) || !Number.isFinite(limite)) {
        return '';
      }
      return valor > limite ? 'relman-pct-bad' : 'relman-pct-good';
    },
    getColorItem(item) {
      if (this.isAbaComunicacao) {
        return null;
      }

      if (!item.cod_equipamento) {
        return "relman-row-vazio";
      }

      if (item.manutencao) {
        return "relman-row-alerta";
      }

      return null;
    },
    getColorPosicao(posicao) {
      if (posicao.is_valid == 0) {
        return "item__com__problema";
      }

      return null;
    }
  }
}
</script>
<style>
.toolbar__container {
  height: fit-content;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 5px grey;
  padding: 20px 15px;
}

.relman-tabs {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 5px 5px grey;
}

/* Linha de posição inválida no diálogo de posições (getColorPosicao). */
.item__com__problema {
  color: #C62828;
  font-weight: bold;
}

/* Aba Equipamentos: destaque sutil de fundo em vez de texto colorido na linha inteira. */
.relman-row-alerta {
  background-color: #FDECEA !important;
}

.relman-row-alerta:hover {
  background-color: #FADBD8 !important;
}

.relman-row-vazio td {
  color: #9e9e9e !important;
  font-style: italic;
}

/* Percentuais com leve cor por limiar (verde/âmbar/vermelho). */
.relman-pct-good {
  color: #2E7D32;
  font-weight: 600;
}

.relman-pct-bad {
  color: #C62828;
  font-weight: 600;
}

.status-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #9e9e9e;
}

.status-geotab-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
